<template>
  <div>
    <div v-html="showingAll ? fullString : shortVersion"/>
    <div v-if="hasMore && !showingAll"
         class="pointer text-primary"
         @click.stop="show">
      {{ $t('show_full') }}
    </div>
    <div v-if="hasMore && showingAll"
         class="pointer text-primary"
         @click.stop="hide">
      {{ $t('hide2') }}
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, onUnmounted } from "vue"

const props = defineProps({
  object: {
    type: Object
  },
  field: {
    type: Object
  },
  index: {
    type: Number,
  }
})

const showingAll = ref(false)

const handleToggle = (e) => {
  if (e.detail.index === props.index) {
    showingAll.value = e.detail.value
  }
}

onMounted(() => {
  document.addEventListener('longtext-toggle', handleToggle)
})

onUnmounted(() => {
  document.removeEventListener('longtext-toggle', handleToggle)
})

const lenLimit = 100

const fullString = computed(() => {
  if(props.field.table_show instanceof Function) {
    return props.field.table_show(props.object)
  }
  return props.object[props.field.id] || ''
})

const shortVersion = computed(() => {
  const str = fullString.value.substring(0, lenLimit)
  if(hasMore.value) {
    return str + '...'
  }
  return str
})

const hasMore = computed(() => {
  return fullString.value.length > lenLimit
})

const show = () => {
  document.dispatchEvent(new CustomEvent('longtext-toggle', {
    detail: {
      index: props.index,
      value: true
    }
  }))
}

const hide = () => {
  document.dispatchEvent(new CustomEvent('longtext-toggle', {
    detail: {
      index: props.index,
      value: false
    }
  }))
}
</script>
